<template>
    <div
        class="ds-ghost-loader relative block bg-gray-100 rounded-full overflow-hidden"
        :class="[classes, noMargin ? null : 'mb-4']"
    />
</template>

<script setup>
    const props = defineProps({
        type: String,
        noMargin: Boolean,
    })

    const classes = computed(() => {
        switch (props.type) {
            case 'h1':
                return 'w-full h-5'
            case 'h2':
                return 'w-4/5 h-4'
            case 'h3':
                return 'w-3/5 h-3'
            case 'h4':
                return 'w-2/5 h-3'
            case 'h5':
                return 'w-1/5 h-2'
            case 'h6':
                return 'w-1/10 h-2'
            case 'label':
                return 'w-1/2 h-2'
            case 'span':
                return 'w-[calc(50%-5px)] h-3 inline-block'
            case 'p':
            default:
                return 'w-full h-3'
        }
    })
</script>

<style scoped>
@keyframes ghost-loading {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: 0 0;
    }
}

.ds-ghost-loader:before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(2,0,36,0) 0%, rgba(0,0,0,0.04) 50%, rgba(0,0,0,0) 100%);
    background-size: 200%;
    animation: ghost-loading 10s linear infinite;
}
</style>
